import { Link } from 'react-router-dom';
import { t, useLocale } from '../i18n';

export default function Impressum() {
    useLocale(); // rerender on locale change
    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-sm uppercase tracking-wide text-slate-500">{t('imprint.legalNotice')}</p>
                    <h1 className="text-3xl font-semibold text-slate-900">{t('imprint.title')}</h1>
                </div>
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 transition"
                >
                    {t('imprint.backHome')}
                </Link>
            </div>

            <div className="space-y-4 text-slate-700">
                <section>
                    <h2 className="text-lg font-semibold text-slate-900">{t('imprint.responsible.title')}</h2>
                    <p className="whitespace-pre-line">{t('imprint.responsible.address')}</p>
                </section>

                <section>
                    <h2 className="text-lg font-semibold text-slate-900">{t('imprint.contact.title')}</h2>
                    <p>{t('imprint.contact.email')}</p>
                    <p>{t('imprint.contact.management')}</p>
                    <p>{t('imprint.contact.register')}</p>
                    <p>{t('imprint.contact.vat')}</p>
                </section>

                <section>
                    <h2 className="text-lg font-semibold text-slate-900">{t('imprint.liability.title')}</h2>
                    <p>{t('imprint.liability.text')}</p>
                    <h2 className="text-lg font-semibold text-slate-900">{t('imprint.privacy.title')}</h2>
                    <p>{t('imprint.privacy.text')}</p>
                </section>
            </div>
        </div>
    );
}
